import React from "react";
import "./functionButton.scss";
import { Link } from "react-router-dom";

const FunctionButton = ({ name, bgColor, color, icon, navigateTo, handleModale }) => {
    return (
        <Link to={navigateTo} className="function-button__container">
            <div
                className="function-button"
                style={{ backgroundColor: bgColor }}
                onClick={() => handleModale && handleModale(true)}
            >
                <div style={{ color: color }}>
                    <i className={icon} style={{ marginRight: "5px" }}></i>
                    {name}
                </div>
            </div>
        </Link>
    );
};

export default FunctionButton;
